import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { productApi, redemptionApi } from '../../services/privateFundApi';
import './RedemptionForm.css';

/**
 * 赎回表单页面
 */
const RedemptionForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [formData, setFormData] = useState({
    redemptionTime: new Date().toISOString().split('T')[0],
    redemptionAmount: ''
  });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      const response = await productApi.getProductById(id);
      if (response.success) {
        setProduct(response.data);
      }
    } catch (err) {
      console.error('获取产品失败:', err);
      setError(err.message || '获取产品失败');
    }
  };

  // 计算预览盈亏
  useEffect(() => {
    if (product && formData.redemptionAmount) {
      const redemptionAmount = parseFloat(formData.redemptionAmount);
      if (redemptionAmount > 0) {
        const profitLoss = redemptionAmount - product.purchaseAmount;
        const profitLossRatio = profitLoss / product.purchaseAmount;
        setPreview({
          profitLoss,
          profitLossRatio
        });
      } else {
        setPreview(null);
      }
    } else {
      setPreview(null);
    }
  }, [formData.redemptionAmount, product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError(null);

      const response = await redemptionApi.createRedemption(id, {
        redemptionTime: formData.redemptionTime,
        redemptionAmount: parseFloat(formData.redemptionAmount)
      });

      if (response.success) {
        navigate(`/private-fund/products/${id}`);
      } else {
        setError(response.message || '记录赎回失败');
      }
    } catch (err) {
      console.error('记录赎回失败:', err);
      setError(err.message || '记录赎回失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/private-fund/products/${id}`);
  };

  if (!product) {
    return (
      <div className="redemption-form">
        <div className="loading-message">加载中...</div>
      </div>
    );
  }

  return (
    <div className="redemption-form">
      <div className="form-header">
        <button className="back-button" onClick={handleCancel}>
          ← 返回
        </button>
        <h1 className="form-title">记录赎回</h1>
      </div>

      <div className="form-content">
        <div className="product-info-card">
          <h3>{product.name}</h3>
          <div className="info-row">
            <span>申购金额:</span>
            <span>{product.purchaseAmount.toLocaleString()} 元</span>
          </div>
        </div>

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="redemptionTime">赎回时间 *</label>
            <input
              type="date"
              id="redemptionTime"
              name="redemptionTime"
              value={formData.redemptionTime}
              onChange={handleChange}
              required
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="redemptionAmount">赎回金额（元） *</label>
            <input
              type="number"
              id="redemptionAmount"
              name="redemptionAmount"
              value={formData.redemptionAmount}
              onChange={handleChange}
              required
              min="0.01"
              step="0.01"
              placeholder="请输入赎回金额"
            />
          </div>

          {preview && (
            <div className="preview-card">
              <h3>盈亏预览</h3>
              <div className="preview-item">
                <span>盈亏金额:</span>
                <span className={preview.profitLoss >= 0 ? 'profit' : 'loss'}>
                  {preview.profitLoss >= 0 ? '+' : ''}{preview.profitLoss.toFixed(2)} 元
                </span>
              </div>
              <div className="preview-item">
                <span>盈亏比例:</span>
                <span className={preview.profitLossRatio >= 0 ? 'profit' : 'loss'}>
                  {preview.profitLossRatio >= 0 ? '+' : ''}{(preview.profitLossRatio * 100).toFixed(2)}%
                </span>
              </div>
            </div>
          )}

          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={handleCancel}>
              取消
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? '保存中...' : '确认赎回'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RedemptionForm;























